export default [
    {
        name: 'auth.login',
        path: '/profile/login',
        component: () => import('@/views/auth/login.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'auth.forgot-password',
        path: '/profile/forgot-password',
        component: () => import('@/views/auth/forgot-password.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'auth.reset-password',
        path: '/profile/reset-password',
        component: () => import('@/views/auth/reset-password.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'auth.verify-confirmation-code',
        path: '/profile/verify-confirmation-code',
        component: () => import('@/views/auth/verify-confirmation-code.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    }
];
